module.exports = __webpack_public_path__ + "img/mercedes-benz-amg-cla-in-car.0f8bb01e.jpg";